export class TechnicalReview {
  public constructor(
    public id: string,
    public name: string,
    public webUrl: URL
  ) {}
}
